import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import { trialResults } from 'components/Filter/mockData';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import { fetchTrialResults, selectTrialResultsPage } from 'store/slices/TrialResults';
import { ROUTES } from 'constants/routes';
// {
//     "fs_title": "Trial results",
//     "fs_title_background": "http://54.93.104.183/storage/posts/OoyDZdcD8zHShvRbW7VV7RQpP58IBKuZb36lwUYD.jpg",
//     "fs_view_button": "View results",
//     "agricultural_tag": "AGRICULTURAL SOLUTIONS",
//     "agricultural_title": "<p>We showcase the results<br /><strong>of our research on different groups of plants</strong></p>",
//     "preview_title": "Trial results",
//     "preview_image": "http://54.93.104.183/storage/posts/sl88GYQRAyShsLYpKs2bfiH4o6ZUk7S1SGrUv2SO.jpg",
//     "preview_text": "We showcase the results of our research on different groups of plants. Here you can find analyzes and conclusions on the effectiveness of products in increasing yields.",
//     "preview_link_text": "Learn more",
//     "crops": [
//       {
//         "slug": "winter-wheat",
//         "title": "Winter wheat",
//         "icon": "http://54.93.104.183/storage/crops/bVjmjZhoRmrKe4YUMNStlCUutypLlfScPMiwrxlg.png"
//       },

//     ]
//   }
// TODO NOT DONE
const TrialResults = () => {
    const dispatch = useDispatch();
    const { fs_title, fs_title_background, fs_view_button, agricultural_tag, agricultural_title, crops } =
        useSelector(selectTrialResultsPage);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchTrialResults());
    }, [dispatch]);

    return (
        <>
            <Banner title={fs_title} image={fs_title_background} buttonText={fs_view_button} />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                {/* TODO wait this field */}
                                !!!!!!!!Here you can find <em>analyzes and conclusions</em> on the
                            </GradientText>
                        </div>
                    </div>
                </div>

                <WithSidebar Sidebar={<Filter data={trialResults} />}>
                    <div className="box">
                        <ProductItems data={crops} baseRoute={ROUTES.trialResults} />
                    </div>
                </WithSidebar>
            </section>

            <DefaultForm />
        </>
    );
};

export default TrialResults;
